import React from 'react';
import "./Landing.css";

export default function Landing({children}: React.PropsWithChildren<{}>) {
  return (
      <div className='container'>
        <div className='content'>
          {children}
        </div>
        <div className='content-img'>
            <picture>
              <img className="nasty-img"
                          src="nasty-goon.jpg"
                          alt="background"/>
            </picture>
        </div>


      </div>

  )
}
